import { useHistory } from "react-router-dom";

export function useRedirect() {
  const history = useHistory();
  const redirectTo = (path: string) => history.push(path);
  return { redirectTo };
}
